export default __webpack_public_path__ + "static/media/HeroBanner.8a780e06.png";